import axios from "axios";

// Always prefer the current origin in browser (avoids stale env vars at build-time
// and eliminates CORS entirely since the K8s ingress routes /api/* to the backend
// on the same domain). Falls back to REACT_APP_BACKEND_URL for SSR / Node scripts.
const browserOrigin = typeof window !== "undefined" ? window.location.origin : "";
export const BACKEND_URL = browserOrigin || process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const ISSUES = [
  { id: "locked_inside", label: "Llaves dentro del coche", desc: "Me he dejado las llaves cerradas dentro del vehículo.", icon: "Lock" },
  { id: "not_working", label: "La llave no funciona", desc: "La llave o mando no responde al abrir o arrancar.", icon: "KeyRound" },
  { id: "lost_key", label: "Pérdida de llave", desc: "He perdido la llave y necesito una nueva ya.", icon: "SearchX" },
  { id: "key_copy", label: "Copia de llave", desc: "Quiero duplicar una llave con chip o mando.", icon: "Copy" },
  { id: "other_problem", label: "Otro problema", desc: "Describe tu caso. Pagas solo el desplazamiento y el técnico evalúa in situ.", icon: "HelpCircle" },
];

export const ISSUE_LABEL = Object.fromEntries(ISSUES.map(i => [i.id, i.label]));

export const STATUS_LABEL = {
  pending: "Pendiente de pago",
  deposit_paid: "Depósito recibido",
  in_progress: "Cerrajero en camino",
  completed: "Trabajo finalizado",
  fully_paid: "Pagado completo",
};
